import { apiFetch } from './api';
import { useAuthStore } from '../store/useAuthStore';

// ---------------------------------------------------------------------------
// Overdue-invoice reminder emails — mirrors backend/src/routes/invoiceReminders.ts.
// /preview pre-fills the send modal server-side (template rendering lives on
// the backend only); /send dispatches the possibly-edited subject/body.
// ---------------------------------------------------------------------------

export interface ReminderPreview {
  subject: string;
  bodyHtml: string;
  to: string | null;
  emailCandidates: string[];
  invoiceIds: string[];
  invoiceCount: number;
  totalOverdue: number;
  currency: string;
}

export interface SendReminderInput {
  clientId: string;
  companyId?: string;
  to: string;
  subject: string;
  bodyHtml: string;
  invoiceIds: string[];
}

export interface SendReminderResult {
  sent: boolean;
  messageId: string;
  sentAt: string;
}

interface Envelope<T> {
  success: true;
  data: T;
}

function authHeaders(): Record<string, string> {
  const token = useAuthStore.getState().accessToken;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** POST /api/invoice-reminders/preview — server-rendered modal pre-fill. */
export async function previewReminder(
  clientId: string,
  companyId?: string,
): Promise<ReminderPreview> {
  const res = await apiFetch<Envelope<ReminderPreview>>('/api/invoice-reminders/preview', {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ clientId, ...(companyId ? { companyId } : {}) }),
  });
  return res.data;
}

/** POST /api/invoice-reminders/send — send the (edited) reminder email. */
export async function sendReminder(input: SendReminderInput): Promise<SendReminderResult> {
  const res = await apiFetch<Envelope<SendReminderResult>>('/api/invoice-reminders/send', {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(input),
  });
  return res.data;
}
